import React, { FC } from "react";
import SegmentedControl from "components/SegmentedControl";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  StorageSearchMode,
  StorageSearchValues,
} from "types/StorageForms/Search";

type SearchModeToggleProps = Pick<
  FormikProps<StorageSearchValues>,
  "values" | "setFieldValue" | "handleSubmit"
>;

// Keeps its width in the flex search row; the input and the chips take the rest.
const Control = styled(SegmentedControl<StorageSearchMode>)`
  flex-shrink: 0;
  margin-right: 10px;
`;

// The Shipments / Items switch above the search input. The mode decides which
// API the form submits to (see searchFormik), so changing it re-runs the
// search. Native radios only fire change for a *different* option, so there is
// no same-value guard.
const SearchModeToggle: FC<SearchModeToggleProps> = ({
  values,
  setFieldValue,
  handleSubmit,
}) => {
  const { t } = useTranslation("common");

  const handleChange = async (mode: StorageSearchMode) => {
    await setFieldValue("searchMode", mode);
    handleSubmit();
  };

  return (
    <Control
      name="searchMode"
      ariaLabel={t("parcels.search.searchMode")}
      options={[
        { value: "shipments", label: t("parcels.search.shipments") },
        { value: "items", label: t("parcels.search.items") },
      ]}
      value={values.searchMode}
      onChange={handleChange}
    />
  );
};

export default SearchModeToggle;
